import api from "./api";

export const checkinService = {
  addCheckin: async (checkinData) => {
    try {
      console.log("Adding new Check in:", checkinData);
      const response = await api.post(`/mapi/check_in/addCheckIn`, checkinData);
      return response.data;
    } catch (error) {
      console.error(
        "Error checking in:",
        error.response?.data || error.message
      );
      throw error;
    }
  },
};

export default checkinService;
